<template>
    <div class="page-wrap">
        <!-- 新增授权书模板 -->
        <createtemplate
            v-if="showCreateTemplate"
            @close-view="handleCloseTemplate" />

        <!-- 编辑授权书模板 -->
        <editcomponent
            v-if="showEditTemplate"
            :editId="currentEditId"
            @close-view="handleCloseTemplate" />

        <!-- 协议列表与普通新增/编辑（非授权书） -->
        <div v-if="!showCreateTemplate && !showEditTemplate"> 

        <!-- 列表页面 -->
        <div class="l-box">
            <div class="input-group">
                <div class="flex f-wrap">
                    <div class="wrap flex"> 
                        <Select v-model="formValidate.type" placeholder="全部" style="width: 200px; margin-left: 20px;">
                            <Option value="">全部</Option>
                            <Option :value="1">授权书</Option>
                            <Option :value="2">数字证书协议</Option>
                            <Option :value="3">隐私协议</Option>
                            <Option :value="4">注销协议</Option>
                        </Select>
                        <Button @click="getListSearch" type="primary" class="search-btn">搜索</Button>
                    </div>
                </div>
            </div>
        </div>

        <div class="table_card">
            <div class="table-wrap">
                <Button type="primary" icon="ios-add" @click="handleAdd">新增协议</Button>
            </div>
            <Table :columns="columnTable" :loading="loading" :data="dataTable" border>
                <template slot-scope="{ index }" slot="index">
                    {{ (formValidate.page - 1) * formValidate.limit + index + 1 }}
                </template>
                <template slot-scope="{ row: rowData }" slot="type">
                    <span v-if="rowData.type === 1">授权书</span>
                    <span v-else-if="rowData.type === 2">数字证书协议</span>
                    <span v-else-if="rowData.type === 3">隐私协议</span>
                    <span v-else-if="rowData.type === 4">注销协议</span>
                    <span v-else>-</span>
                </template>
                <template slot-scope="{ row }" slot="is_use">
                    <i-switch
                        v-model="row.is_use"
                        :true-value="1"
                        :false-value="0"
                        size="large"
                        @on-change="handleToggleStatus(row)">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div class="flex-c">
                        <Button type="primary" size="small" @click="handleEdit(row)" style="margin-right: 8px;">编辑</Button>
                        <Button type="error" size="small" @click="handleDelete(row)">删除</Button>
                    </div>
                </template>
            </Table>
            <Page
                :total="total"
                :current="formValidate.page"
                style="text-align:right;margin-top: 20px"
                show-elevator
                show-total
                @on-change="pageChange"
                :page-size="formValidate.limit" />
        </div>
        </div>
    </div>
</template>

<script>
import createtemplate from './components/createtemplate.vue'
import editcomponent from './components/editcomponent.vue'
import {
    addLicenseAgreement,
    editLicenseAgreement,
    getTemplateList,
    setTemplateStatus,
    delTemplate
} from '@/api/operation'

export default {
    name: "licenseagree",
    components: {
        createtemplate,
        editcomponent
    },
    data() {
        return {
            showModal: false,
            modalTitle: '新增协议',
            loading: false,
            total: 0,
            dataTable: [],
            formValidate: {
                type: '',
                page: 1,
                limit: 10
            },
            // 授权书模板相关
            showCreateTemplate: false,
            showEditTemplate: false,
            currentEditId: null,
            formData: {
                id: null,
                file_name: '',
                type: null,
                file_url: '',
                is_use: 1
            },
            ruleValidate: {
                file_name: [
                    { required: true, message: '请输入文件名称', trigger: 'blur' }
                ],
                type: [
                    { required: true, type: 'number', message: '请选择类型', trigger: 'change' }
                ]
            },
            columnTable: [
                {
                    title: '序号',
                    slot: 'index',
                    align: 'center',
                    width: 80
                },
                {
                    title: '文件名称',
                    key: 'file_name',
                    align: 'center'
                },
                {
                    title: '类型',
                    slot: 'type',
                    align: 'center'
                },
                {
                    title: '是否使用',
                    slot: 'is_use',
                    align: 'center',
                    width: 120
                },
                {
                    title: '创建时间',
                    key: 'created_at',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 180,
                    align: 'center'
                }
            ]
        }
    },
    created() {
        this.$store.commit('changePollingSpin', false)
        this.getlist()
    },
    methods: {
        // 获取列表
        getlist() {
            this.loading = true
            const params = {
                page: this.formValidate.page,
                limit: this.formValidate.limit
            }
            if (this.formValidate.type) {
                // 前端和接口类型一致：1授权书 2数字证书协议 3隐私协议
                params.type = this.formValidate.type
            }
            // 使用新的模板列表接口
            getTemplateList(params).then(res => {
                if (res.code === 200 && res.data) {
                    // Laravel 分页格式适配
                    this.total = res.data.total || 0
                    // 数据字段映射：name -> file_name, status -> is_use
                    this.dataTable = (res.data.data || []).map(item => ({
                        id: item.id,
                        file_name: item.name || '',
                        type: item.type,
                        file_url: '',
                        is_use: item.status === 1 ? 1 : 0,
                        created_at: item.created_at || ''
                    }))
                } else {
                    this.total = 0
                    this.dataTable = []
                }
                this.loading = false
            }).catch(res => {
                this.loading = false
                this.$Message.error(res.msg || '获取列表失败')
                this.total = 0
                this.dataTable = []
            })
        },
        // 搜索
        getListSearch() {
            this.formValidate.page = 1
            this.getlist()
        },
        // 分页
        pageChange(index) {
            this.formValidate.page = index
            this.getlist()
        },
        // 新增
        handleAdd() {
            // 新增统一走模板创建页面
            this.showCreateTemplate = true
            this.showEditTemplate = false
        },
        // 编辑
        handleEdit(row) {
            // 编辑统一走模板编辑页面
            this.currentEditId = row.id
            this.showEditTemplate = true
            this.showCreateTemplate = false
        },
        // 删除
        handleDelete(row) {
            this.$Modal.confirm({
                title: '操作提示',
                content: '请问您是否确认删除此模板，删除后无法恢复！',
                onOk: () => {
                    delTemplate({ id: row.id }).then(res => {
                        this.$Message.success(res.msg || '删除成功')
                        this.getlist()
                    }).catch(res => {
                        this.$Message.error(res.msg || '删除失败')
                    })
                }
            })
        },
        // 切换使用状态
        handleToggleStatus(row) {
            const status = row.is_use === 1 ? 1 : 0
            setTemplateStatus({
                id: row.id,
                status: status,
                type: row.type  // 模板类型：1授权书 2数字证书协议 3隐私协议
            }).then(res => {
                this.$Message.success(res.msg || '操作成功')
                row.is_use = status
                this.getlist()
            }).catch(res => {
                this.$Message.error(res.msg || '操作失败')
                // 恢复原状态
                row.is_use = row.is_use === 1 ? 0 : 1
            })
        },
        // 提交表单
        handleSubmit() {
            this.$refs.formValidate.validate((valid) => {
                if (valid) {
                    const api = this.formData.id ? editLicenseAgreement : addLicenseAgreement
                    api(this.formData).then(res => {
                        this.$Message.success(res.msg || '操作成功')
                        this.showModal = false
                        this.getlist()
                    }).catch(res => {
                        this.$Message.error(res.msg || '操作失败')
                    })
                }
            })
        },
        // 取消
        handleCancel() {
            this.showModal = false
            this.$refs.formValidate.resetFields()
        },
        // 关闭授权书模板新增/编辑页面，保持当前页与筛选条件并刷新列表
        handleCloseTemplate() {
            this.showCreateTemplate = false
            this.showEditTemplate = false
            this.currentEditId = null
            // 保留当前 page 与 type，只刷新数据
            this.getlist()
        },
        // 文件上传前
        handleBeforeUpload(file) {
            const isValidType = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)
            const isLt10M = file.size / 1024 / 1024 < 10

            if (!isValidType) {
                this.$Message.error('文件格式不正确，请上传 PDF 或 Word 文档！')
                return false
            }
            if (!isLt10M) {
                this.$Message.error('文件大小不能超过 10MB！')
                return false
            }
            return true
        },
        // 文件上传成功
        handleUploadSuccess(response) {
            if (response.code === 0 || response.status === 0) {
                this.formData.file_url = response.data.url || response.data.file_url || response.url
                this.$Message.success('文件上传成功')
            } else {
                this.$Message.error(response.msg || '文件上传失败')
            }
        },
        // 文件上传失败
        handleUploadError() {
            this.$Message.error('文件上传失败，请重试')
        }
    }
}
</script>

<style scoped>
.page-wrap .l-box {
    background: #FFFFFF;
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.page-wrap .l-box .input-group {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.page-wrap .l-box .input-group .wrap {
    display: flex;
    align-items: center;
}

.page-wrap .l-box .input-group .wrap .label {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
}

.page-wrap .l-box .input-group .wrap .search-btn {
    margin-left: 20px;
}

.page-wrap .table_card {
    width: 100%;
    min-height: 500px;
    padding: 24px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 8px;
}

.page-wrap .table_card .table-wrap {
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-start;
}

.page-wrap .flex-c {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
